var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "groupDrawer" }, [
    _c("div", { staticClass: "form" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "page_wrap",
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c("div", { staticClass: "header_tips" }, [_vm._v("基本信息")]),
              _c(
                "div",
                { staticClass: "m-t-20" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "大专栏名称", prop: "contentName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "690px" },
                        attrs: {
                          maxlength: "45",
                          type: "text",
                          "show-word-limit": "",
                        },
                        on: { input: _vm.handleInputChange },
                        model: {
                          value: _vm.form.contentName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "contentName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.contentName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "课程预计课时", prop: "classHour" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          "controls-position": "right",
                          min: _vm.form.copyClassHour,
                          step: 1,
                          "step-strictly": "",
                        },
                        model: {
                          value: _vm.form.classHour,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "classHour", $$v)
                          },
                          expression: "form.classHour",
                        },
                      }),
                      _vm._v(
                        " 上架保存之后只能增加不能减少，请按实际情况填写 "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "大专栏简介", prop: "columnContent" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.columnContent,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "columnContent",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.columnContent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择IP", prop: "lecturerIdList" } },
                    [
                      _c("m-select", {
                        staticClass: "m-300",
                        staticStyle: { width: "205px" },
                        attrs: {
                          disabled: "",
                          filterable: "",
                          placeholder: "请选择老师",
                          multiple: "",
                          "dict-list": _vm.teacherOption,
                          param: { value: "lecturerId", label: "lecturerName" },
                        },
                        model: {
                          value: _vm.form.lecturerIdList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lecturerIdList", $$v)
                          },
                          expression: "form.lecturerIdList",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择类别", prop: "curriculumType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择类型" },
                          model: {
                            value: _vm.form.curriculumType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "curriculumType", $$v)
                            },
                            expression: "form.curriculumType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 1, label: "基础课" },
                          }),
                          _c("el-option", {
                            attrs: { value: 2, label: "进阶课" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "人气值", prop: "goodsPopularity" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: { "controls-position": "right" },
                        model: {
                          value: _vm.form.goodsPopularity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "goodsPopularity", _vm._n($$v))
                          },
                          expression: "form.goodsPopularity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品主图", prop: "coverUrlList" } },
                    [
                      _c("ImageUpload", {
                        attrs: { limit: 8 },
                        on: { change: _vm.getCoverUrlList },
                        model: {
                          value: _vm.form.coverUrlList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "coverUrlList", $$v)
                          },
                          expression: "form.coverUrlList",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "大专栏封面", prop: "patchUrl" } },
                    [
                      _c("div", [
                        !_vm.form.patchUrl
                          ? _c(
                              "div",
                              {
                                staticClass: "image_poster",
                                staticStyle: {
                                  width: "200px",
                                  height: "112px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getImgUrl("patchUrl")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _c("span", [_vm._v("点击上传图片")]),
                              ]
                            )
                          : _c(
                              "div",
                              [
                                _c("AppMyImage", {
                                  staticStyle: {
                                    width: "200px",
                                    height: "112px",
                                  },
                                  attrs: {
                                    src: _vm.form.patchUrl,
                                    options: {
                                      width: 567,
                                      fixed: true,
                                      option: {
                                        fixed: true,
                                        fixedNumber: [16, 9],
                                        fixedBox: false,
                                      },
                                    },
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.delImage("patchUrl")
                                    },
                                    success: (res) =>
                                      _vm.changeImage("patchUrl", res),
                                  },
                                }),
                              ],
                              1
                            ),
                        _c("div", { staticClass: "tips m-t-20" }, [
                          _c("div", [
                            _vm._v(
                              " 大专栏封面是指专栏展示的图片，建议尺寸750*422或比例16：9， "
                            ),
                          ]),
                          _c("div", [_vm._v("小于500K的JPG格式图片")]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "横版缩略图", prop: "coverUrl" } },
                    [
                      _c("div", [
                        !_vm.form.coverUrl
                          ? _c(
                              "div",
                              {
                                staticClass: "image_poster",
                                staticStyle: {
                                  width: "200px",
                                  height: "150px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getImgUrl("coverUrl")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _c("span", [_vm._v("点击上传图片")]),
                              ]
                            )
                          : _c(
                              "div",
                              [
                                _c("AppMyImage", {
                                  staticStyle: {
                                    width: "200px",
                                    height: "150px",
                                  },
                                  attrs: {
                                    src: _vm.form.coverUrl,
                                    options: {
                                      width: 567,
                                      fixed: true,
                                      option: {
                                        fixed: true,
                                        fixedNumber: [4, 3],
                                        fixedBox: false,
                                      },
                                    },
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.delImage("coverUrl")
                                    },
                                    success: (res) =>
                                      _vm.changeImage("coverUrl", res),
                                  },
                                }),
                              ],
                              1
                            ),
                        _c("div", { staticClass: "tips m-t-20" }, [
                          _c("div", [
                            _vm._v("横版缩略图是指在商品列表展示的图片。"),
                          ]),
                          _c("div", [
                            _vm._v(
                              "建议尺寸750*563或比例4:3，小于500K的JPG格式图片"
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "学习说明" } },
                    _vm._l(_vm.learnExplain, function (item, index) {
                      return _c(
                        "el-row",
                        { key: index, staticClass: "m-b-10" },
                        [
                          _c("el-input", {
                            staticClass: "m-r-10",
                            staticStyle: { width: "500px" },
                            attrs: {
                              type: "textarea",
                              row: 5,
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.learnExplain[index],
                              callback: function ($$v) {
                                _vm.$set(_vm.learnExplain, index, $$v)
                              },
                              expression: "learnExplain[index]",
                            },
                          }),
                          _vm.learnExplain.length === index + 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addLearnExplain(item)
                                    },
                                  },
                                },
                                [_vm._v("添加")]
                              )
                            : _vm._e(),
                          _vm.learnExplain.length !== 1
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.learnExplain.splice(index, 1)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "大专栏详情", prop: "content" } },
                    [
                      _c("AppUEditor", {
                        ref: "AppUEditor",
                        on: { change: _vm.change },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "金句", prop: "goldenSentence" } },
                    _vm._l(_vm.goldenSentence, function (item, index) {
                      return _c(
                        "el-row",
                        { key: index, staticClass: "m-b-10" },
                        [
                          _c("el-input", {
                            staticClass: "m-r-10",
                            staticStyle: { width: "500px" },
                            attrs: {
                              type: "textarea",
                              row: 5,
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.goldenSentence[index],
                              callback: function ($$v) {
                                _vm.$set(_vm.goldenSentence, index, $$v)
                              },
                              expression: "goldenSentence[index]",
                            },
                          }),
                          _vm.goldenSentence.length === index + 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addGoldenSentence(item)
                                    },
                                  },
                                },
                                [_vm._v("添加")]
                              )
                            : _vm._e(),
                          _vm.goldenSentence.length !== 1
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goldenSentence.splice(index, 1)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "相关资料" } }, [
                    _c("div", { staticClass: "btnfl" }, [
                      _c(
                        "div",
                        {
                          staticClass: "add-course-ware-btn m-r-20",
                          on: {
                            click: function ($event) {
                              return _vm.getInforMationPic()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v("添加资料 "),
                        ]
                      ),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v(
                          " 最多添加300个文件(后缀为pdf),单个文件不能大于100M;专栏和视频中均存在资料,只显示专栏中资料。 "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ZiliaoTable" },
                      [
                        _vm.form.informationPicReqList.length > 0
                          ? _c(
                              "el-table",
                              {
                                staticClass: "m-t-20",
                                staticStyle: { width: "800px" },
                                attrs: {
                                  "header-cell-style": {
                                    background: "#f5f5f5",
                                    padding: "0",
                                  },
                                  data: _vm.form.informationPicReqList,
                                  "max-height": "450",
                                  "row-key": "materialId",
                                  "cell-class-name": "cursorMove",
                                  border: "",
                                },
                              },
                              [
                                _c(
                                  "el-table-column",
                                  { attrs: { width: "50", align: "center" } },
                                  [[_c("i", { staticClass: "el-icon-rank" })]],
                                  2
                                ),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "materialName",
                                    label: "文件",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "materialSize",
                                    label: "大小",
                                    width: "120",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("filterSize")(
                                                    scope.row.materialSize
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3656052527
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "createTime",
                                    label: "上传时间",
                                    width: "240",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "操作", width: "240" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.deleteRow(
                                                      scope.$index,
                                                      _vm.form
                                                        .informationPicReqList
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 移除 ")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    973411999
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "btnfl m-t-20" }, [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "add-course-ware-btn m-r-20",
                              on: { click: _vm.selectPPT },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v("添加PPT "),
                            ]
                          ),
                          _c("pdfUpload", {
                            ref: "pdfUpload",
                            attrs: { loading: _vm.pdfLoading },
                            on: {
                              "update:loading": function ($event) {
                                _vm.pdfLoading = $event
                              },
                              del: _vm.handleDelPDF,
                              change: _vm.pptChange,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v(
                          " 最多添加200张jpg/png图片,单张图片不能大于2M;专栏和视频中均存在图片,只显示视频中图片。 "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "PPTTable" },
                      [
                        _vm.form.informationPptReqList.length > 0
                          ? _c(
                              "el-table",
                              {
                                staticStyle: {
                                  width: "800px",
                                  "margin-top": "20px",
                                },
                                attrs: {
                                  "header-cell-style": {
                                    background: "#f5f5f5",
                                    padding: "0",
                                  },
                                  data: _vm.form.informationPptReqList,
                                  "max-height": "450",
                                  "row-key": "materialId",
                                  "cell-class-name": "cursorMove",
                                  border: "",
                                },
                              },
                              [
                                _c(
                                  "el-table-column",
                                  { attrs: { width: "50", align: "center" } },
                                  [[_c("i", { staticClass: "el-icon-rank" })]],
                                  2
                                ),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "materialName",
                                    label: "文件",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ row }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "fl fl_ai_c" },
                                              [
                                                _c("el-image", {
                                                  staticStyle: {
                                                    width: "100px",
                                                    height: "100px",
                                                  },
                                                  attrs: {
                                                    src: row.materialUrl,
                                                    "preview-src-list":
                                                      _vm.srcList,
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "m-l-20" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "m-picture-title",
                                                        attrs: {
                                                          title:
                                                            row.materialName,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              row.materialName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "m-picture-property",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "filterDes"
                                                              )(row.materialDes)
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3777766578
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "materialSize",
                                    label: "大小",
                                    width: "120",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("filterSize")(
                                                    scope.row.materialSize
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3656052527
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "createTime",
                                    label: "上传时间",
                                    width: "240",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "操作", width: "80" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.deleteRow(
                                                      scope.$index,
                                                      _vm.form
                                                        .informationPptReqList
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 移除 ")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3199356017
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "header_tips" }, [_vm._v("商品信息")]),
              _c(
                "div",
                { staticClass: "m-t-20" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "售卖方式", prop: "sale" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 0, "false-label": 1 },
                          model: {
                            value: _vm.form.relationSaleFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "relationSaleFlag", $$v)
                            },
                            expression: "form.relationSaleFlag",
                          },
                        },
                        [_vm._v("支持单独售卖")]
                      ),
                      _c("span", [
                        _vm._v("客户可以通过店铺或链接的方式单独购买该商品"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "sale-container m-b-20 m-l-20" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { width: "776px" },
                              on: { change: _vm.saleTypeChange },
                              model: {
                                value: _vm.form.materialSalePicReq.saleType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.materialSalePicReq,
                                    "saleType",
                                    $$v
                                  )
                                },
                                expression: "form.materialSalePicReq.saleType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("免费"),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("付费"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _vm.form.materialSalePicReq.saleType === 1
                                ? [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "20px",
                                        },
                                        attrs: {
                                          label: "商品价格",
                                          prop: "materialSalePicReq.salePrice",
                                          rules:
                                            _vm.rules.materialSalePicReqRule
                                              .salePrice,
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticClass: "w-200 m-r-10",
                                          attrs: {
                                            min: 0.0001,
                                            "controls-position": "right",
                                          },
                                          model: {
                                            value:
                                              _vm.form.materialSalePicReq
                                                .salePrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.materialSalePicReq,
                                                "salePrice",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "form.materialSalePicReq.salePrice",
                                          },
                                        }),
                                        _c("span", { staticClass: "m-l-10" }, [
                                          _vm._v("元"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "20px",
                                        },
                                        attrs: {
                                          label: "划线价格",
                                          prop: "materialSalePicReq.marketPrice",
                                          rules:
                                            _vm.rules.materialSalePicReqRule
                                              .marketPrice,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            type: "number",
                                            min: 0,
                                            "controls-position": "right",
                                          },
                                          model: {
                                            value:
                                              _vm.form.materialSalePicReq
                                                .marketPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.materialSalePicReq,
                                                "marketPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.materialSalePicReq.marketPrice",
                                          },
                                        }),
                                        _c("span", { staticClass: "m-l-10" }, [
                                          _vm._v("元"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "tips m-t-10" }, [
                                      _vm._v(
                                        " 商品没有其他优惠（如拼团）的情况下，划线价格在商品详情会以划线形式显示 "
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                              _vm.form.materialSalePicReq.saleType === 2
                                ? _c("div", { staticClass: "m-b-10" }, [
                                    _c(
                                      "div",
                                      { staticClass: "sale-input__label" },
                                      [_vm._v("密码")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "sale-input__input" },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "328px" },
                                          attrs: {
                                            placeholder:
                                              "请设置3-12位字母、数字或汉字格式密码",
                                          },
                                          model: {
                                            value:
                                              _vm.form.materialSalePicReq
                                                .password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.materialSalePicReq,
                                                "password",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.materialSalePicReq.password",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.form.materialSalePicReq.saleType === 3
                                ? _c("div", { staticClass: "tips m-b-10" }, [
                                    _vm._v(
                                      " 仅被指定学员可免费学习课程，添加指定学员请前往【课程详情-学员列表】手动操作 "
                                    ),
                                  ])
                                : _vm._e(),
                              _c("div", [
                                _c("div", { staticClass: "vaildTimeText" }, [
                                  _vm._v("课程有效期"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "validTime" },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value:
                                            _vm.form.materialSalePicReq
                                              .saleValidity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.materialSalePicReq,
                                              "saleValidity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.materialSalePicReq.saleValidity",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            staticClass: "w-500 m-b-20",
                                            attrs: { label: 0, disabled: "" },
                                          },
                                          [_vm._v("长期有效")]
                                        ),
                                        _c(
                                          "el-radio",
                                          {
                                            staticClass: "w-500 m-b-20",
                                            attrs: {
                                              label: 1,
                                              disabled:
                                                _vm.form.materialSalePicReq
                                                  .saleType === 0,
                                            },
                                          },
                                          [
                                            _vm._v(" 购买后 "),
                                            _c("el-input-number", {
                                              staticClass: "w-200 m-r-10",
                                              attrs: {
                                                disabled:
                                                  _vm.form.materialSalePicReq
                                                    .saleValidity !== 1,
                                                min: 1,
                                                max: 9999,
                                                "controls-position": "right",
                                              },
                                              model: {
                                                value:
                                                  _vm.form.materialSalePicReq
                                                    .validityDays,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form.materialSalePicReq,
                                                    "validityDays",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "\n                            form.materialSalePicReq.validityDays\n                          ",
                                              },
                                            }),
                                            _c("span", [_vm._v("天有效")]),
                                            _c(
                                              "el-checkbox",
                                              {
                                                staticClass: "m-l-20",
                                                attrs: {
                                                  "true-label": 0,
                                                  "false-label": 1,
                                                  disabled:
                                                    _vm.form.materialSalePicReq
                                                      .saleValidity !== 1,
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.materialSalePicReq
                                                      .repeatPurchase,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form
                                                        .materialSalePicReq,
                                                      "repeatPurchase",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.materialSalePicReq.repeatPurchase",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " 允许学员在有效期内重复购买 "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "tips m-l-20 m-b-20" }, [
                        _vm._v(
                          " 课程带货：可同时关联实物商品和课程售卖，实物商品运费由商家承担，最多支持添加10个实物商品和课程 "
                        ),
                      ]),
                      _vm.form.saleFlag === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "add-course-ware-btn m-l-20",
                              staticStyle: { width: "195px" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectColumn()
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" 选择专栏/训练营 "),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺商品分类" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.goodsGroupingOption,
                          placeholder: "选择店铺商品分类",
                          props: {
                            multiple: true,
                            value: "catalogueId",
                            label: "catalogueName",
                            children: "catalogueVos",
                            expandTrigger: "hover",
                            checkStrictly: true,
                            emitPath: false,
                          },
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.groupingPicReqList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "groupingPicReqList", $$v)
                          },
                          expression: "form.groupingPicReqList",
                        },
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.catalogueLoading,
                              expression: "catalogueLoading",
                            },
                          ],
                          staticClass: "EC1 m-l-20 pointer",
                          attrs: {
                            "element-loading-spinner": "el-icon-loading",
                          },
                          on: { click: _vm._getCatalogueList },
                        },
                        [_vm._v(" 刷新 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "平台商品分类",
                        prop: "catalogueReqList",
                      },
                    },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.platformGoodsGroupingOption,
                          placeholder: "选择商品分类",
                          props: {
                            multiple: true,
                            value: "catalogueId",
                            label: "catalogueName",
                            children: "catalogueVos",
                            expandTrigger: "hover",
                            checkStrictly: true,
                            emitPath: false,
                          },
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.catalogueReqList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "catalogueReqList", $$v)
                          },
                          expression: "form.catalogueReqList",
                        },
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.catalogueLoading,
                              expression: "catalogueLoading",
                            },
                          ],
                          staticClass: "EC1 m-l-20 pointer",
                          attrs: {
                            "element-loading-spinner": "el-icon-loading",
                          },
                          on: { click: _vm._getPlatformCatalogueList },
                        },
                        [_vm._v(" 刷新 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "自定义锚点" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "328px" },
                        attrs: {
                          placeholder: "请输入自定义锚点",
                          maxlength: "12",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.anchorInfo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "anchorInfo", $$v)
                          },
                          expression: "form.anchorInfo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "header_tips m-t-50" }, [
                _vm._v("服务与履约"),
              ]),
              _c(
                "div",
                { staticClass: "m-t-20" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "售后服务" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.form.postSaleType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "postSaleType", $$v)
                            },
                            expression: "form.postSaleType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "未学七天可退", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "不支持退款", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "m-t-20" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "服务保障" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.showServiceGuarantee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "showServiceGuarantee", $$v)
                          },
                          expression: "form.showServiceGuarantee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "header_tips m-t-50" }, [
                _vm._v("上架设置"),
              ]),
              _c(
                "div",
                { staticClass: "m-t-20" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上架设置" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.shelveFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shelveFlag", $$v)
                            },
                            expression: "form.shelveFlag",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticClass: "m-t-10",
                              staticStyle: { width: "100%" },
                              attrs: { label: 0 },
                            },
                            [_vm._v("立即上架")]
                          ),
                          _c(
                            "el-radio",
                            { staticClass: "m-t-10", attrs: { label: 2 } },
                            [
                              _c("span", [_vm._v("定时上架")]),
                              _c("el-date-picker", {
                                staticClass: "m-l-20",
                                attrs: {
                                  disabled: _vm.form.shelveFlag !== 2,
                                  type: "datetime",
                                  placeholder: "请设置时间",
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.form.shelveTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "shelveTime", $$v)
                                  },
                                  expression: "form.shelveTime",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-radio",
                            {
                              staticClass: "m-t-10",
                              staticStyle: { width: "100%" },
                              attrs: { label: 1 },
                            },
                            [_vm._v("暂不上架")]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "EC1 m-t-20 m-b-10" }, [
                        _vm._v("更多设置"),
                      ]),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.shelveHideFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "shelveHideFlag", $$v)
                                },
                                expression: "form.shelveHideFlag",
                              },
                            },
                            [_vm._v("隐藏")]
                          ),
                          _c("span", { staticClass: "tips m-l-20" }, [
                            _vm._v(
                              "上架的商品设置隐藏后，在店铺内不显示，但可以通过链接的方式访问"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.androidHideFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "androidHideFlag", $$v)
                                },
                                expression: "form.androidHideFlag",
                              },
                            },
                            [_vm._v("在APP-安卓端隐藏")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.iosHideFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "iosHideFlag", $$v)
                                },
                                expression: "form.iosHideFlag",
                              },
                            },
                            [_vm._v("在APP-IOS端隐藏")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.appletHideFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "appletHideFlag", $$v)
                                },
                                expression: "form.appletHideFlag",
                              },
                            },
                            [_vm._v("在微信小程序端隐藏")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.douAppletHideFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "douAppletHideFlag", $$v)
                                },
                                expression: "form.douAppletHideFlag",
                              },
                            },
                            [_vm._v("在抖音小程序端隐藏")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.htmlHideFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "htmlHideFlag", $$v)
                                },
                                expression: "form.htmlHideFlag",
                              },
                            },
                            [_vm._v("在H5隐藏")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.form.shelveHaltFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "shelveHaltFlag", $$v)
                                },
                                expression: "form.shelveHaltFlag",
                              },
                            },
                            [_vm._v("停售")]
                          ),
                          _c("span", { staticClass: "tips m-l-20" }, [
                            _vm._v("上架的商品设置停售后，将停止售卖"),
                          ]),
                        ],
                        1
                      ),
                      _c("el-divider"),
                      _c("div", { staticClass: "tips" }, [
                        _c("i", { staticClass: "el-icon-warning" }),
                        _vm._v(
                          " 根据您上传的图文大小需要0-30分钟不等的转码时间，转码过程中该商品将隐藏不可显示，转码完成后会根据您的设置进行显示/隐藏。 "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "demo-drawer__footer" },
      [
        _c(
          "el-button",
          {
            attrs: { size: "small" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v("取 消")]
        ),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: {
              click: function ($event) {
                return _vm.save()
              },
            },
          },
          [_vm._v("提交")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }